<template>
  <component
    :is="element"
    class="header-banner"
    :class="$blockClass(blockClass, 'banner-container')"
    :href="settings.url.includes('visualizer') ? settings.url + '/headboard' : settings.url"
  >
    <responsive-image
      v-if="settings.image"
      :alt="settings.title"
      :image="{src: settings.image}"
      :ratio="imageRatio"
      :class="$blockClass(blockClass, 'banner-image')"
      class="header-banner__image"
    />

    <div
      class="header-banner__content lazyload"
      :class="$blockClass(blockClass, 'banner-content')"
    >
      <h6
        v-if="settings.title"
        class="header-banner__title"
        :class="$blockClass(blockClass, 'banner-title')"
        v-text="settings.title"
      />
      <p
        v-if="settings.description"
        class="body-2 header-banner__description"
        :class="$blockClass(blockClass, 'banner-description')"
        v-text="settings.description"
      />
      <span
        v-if="settings.url_text && settings.url"
        class="header-banner__link button button--text"
        :class="$blockClass(blockClass, 'banner-link')"
      >
        <span
          class="button__label"
          v-text="settings.url_text"
        />
      </span>
    </div>
  </component>
</template>

<script>

/**
 * Vue: Header banner (header-banner)
 * -----------------------------------------------------------------------------
 * A banner card with text overlay that lives inside the site header and menu drawer.
 *
 */
export default {
  name: 'HeaderBanner',

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    imageRatio: {
      type: String,
      default: '280:220',
    },
    settings: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {}
  },

  computed: {
    element() {
      return this.settings.url_text && this.settings.url ? 'a' : 'div'
    },
  },
}
</script>

<style lang="scss">
@import './header-banner';
</style>
